import { render } from "./ColorPickerForm.vue?vue&type=template&id=db48f63e&scoped=true"
import script from "./ColorPickerForm.vue?vue&type=script&lang=js"
export * from "./ColorPickerForm.vue?vue&type=script&lang=js"

import "./ColorPickerForm.vue?vue&type=style&index=0&id=db48f63e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-db48f63e"

export default script